import React from 'react';
import { View, Text, ScrollView } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isWeb } from '@helpers';
import { SmallLoading } from '@components/loading';
import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';
import ColorWrapper from '@styles/colors';
import Line from '@components/common/line';
import Button from '@styles/buttons';
import Header from '@components/settings/v2/common/SettingsHeader';
import { BACK_BUTTON_SETTINGS_TEXT, SCREEN_BORDER_RADIUS, SCREEN_PADDING_HORIZONTAL, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { useManageDevicesMobile } from './hooks/useManageDevicesMobile';

const Devices = ({ C, rootStack }) => {
  const { wallboard, other, loaded, navigateToAddDevice } = useManageDevicesMobile({ rootStack });

  const shadowStyles = getBoxShadowStyle({ type: 'Field', C });

  const HeaderAction = () => (
    <View style={{ position: 'absolute', right: scale(10), top: scale(isWeb ? 9 : 24), zIndex: 100000 }}>
      <Button
        {...{
          variant: 'S',
          type: 'Primary',
          onPress: navigateToAddDevice,
        }}
      >
        {i18n.t('Add Device')}
      </Button>
    </View>
  );

  return (
    <View key="UsersList" style={{ width: '100%', backgroundColor: C('Background/Light/Detail'), height: '100%' }}>
      <Header backBtnText={BACK_BUTTON_SETTINGS_TEXT} name={'Devices'} action={navigateToAddDevice} />
      {!wallboard.length && !other.length && loaded && (
        <View style={{ width: '100%', marginTop: scale(200), justifyContent: 'center', height: scale(50), justifyContent: 'center' }}>
          <Text style={[font.Body, { color: C('Label/Light/Primary'), textAlign: 'center' }]}>{i18n.t('Not found')}</Text>
        </View>
      )}
      {!loaded ? (
        <View style={{ width: '100%', marginTop: scale(200), justifyContent: 'center', height: scale(50) }}>
          <SmallLoading />
        </View>
      ) : (
        <ScrollView style={{ width: '100%', flex: 1 }} contentContainerStyle={{ paddingBottom: scale(50) }}>
          <View style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL) }}>
            {Boolean(wallboard.length) && (
              <View testID={TEST_IDS.settingsScreen.devicesWallboardSection}>
                <View style={{ paddingLeft: scale(15), flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Text style={[{ color: C('Label/Light/Tertiary') }, font['Footnote']]}>{i18n.t('WALLBOARDS')}</Text>
                </View>
                <View style={{ width: '100%' }}>
                  <View style={[shadowStyles, { marginTop: scale(5), width: '100%', borderRadius: scale(SCREEN_BORDER_RADIUS) }]}>
                    {wallboard.map((i, index) => (
                      <Line
                        key={i.deviceId}
                        {...{
                          item: i,
                          index,
                          array: wallboard,
                          bigSize: true,
                          C,
                          topBorder: index !== 0,
                          roundTop: index === 0,
                          roundBottom: index === wallboard.length - 1,
                        }}
                      />
                    ))}
                  </View>
                </View>
              </View>
            )}
            {Boolean(other.length) && (
              <View testID={TEST_IDS.settingsScreen.devicesOtherSection}>
                <View style={{ paddingLeft: scale(15), flexDirection: 'row', justifyContent: 'space-between', marginTop: scale(15) }}>
                  <Text style={[{ color: C('Label/Light/Tertiary') }, font['Footnote']]}>{i18n.t('OTHER DEVICES')}</Text>
                </View>
                <View style={{ width: '100%' }}>
                  <View style={[shadowStyles, { marginTop: scale(5), width: '100%', borderRadius: scale(SCREEN_BORDER_RADIUS) }]}>
                    {other.map((i, index) => (
                      <Line
                        key={i.deviceId}
                        {...{
                          item: i,
                          index,
                          array: other,
                          bigSize: true,
                          C,
                          topBorder: index !== 0,
                          roundTop: index === 0,
                          roundBottom: index === other.length - 1,
                        }}
                      />
                    ))}
                  </View>
                </View>
              </View>
            )}
          </View>
        </ScrollView>
      )}
    </View>
  );
};

export default ColorWrapper(Devices);
